/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {translate} from '@ion/core/src/locale/locale';
import {Entity} from '@ion/core/src/types/entities';

type EntityName = {
  name?: string;
  username?: string;
}

const getField = (isUser = false) => !isUser ? 'name' : 'username';

/**
 * Determines the delete message for an entity.
 */
export const getEntityDeleteMessage = (entity: EntityName, isUser = false): string => {
  return translate('common:editors.delete.singleDeleteMessage', {entity: entity[getField(isUser)]});
};

/**
 * Determines and returns the bulk delete message for 2, 3, and 4+ entities.
 */
export const getBulkEntityDeleteMessage = (entity: Entity, entities: EntityName[], isUser = false): string => {
  const [firstEntity, secondEntity, thirdEntity] = entities;
  const count = entities?.length;
  if (count === 2 || count === 3) {
    const field = getField(isUser);
    return translate(`common:editors.delete.${count === 2 ? 'dual' : 'triple'}DeleteMessage`, {
      firstEntity  : firstEntity[field],
      secondEntity : secondEntity[field],
      thirdEntity  : thirdEntity?.[field]
    });
  }
  return translate('common:editors.delete.multipleDeleteMessage', {
    entities : translate(`common:entityLabels.${entity}s`),
    count
  });
};

/**
 * Returns 'yes' translation if the given boolean is true and 'no' translation if false.
 */
export const getBooleanTranslation = (booleanToTranslate: boolean): string => {
  return translate(`common:booleans.${booleanToTranslate ? 'yes' : 'no'}`);
};
